// @flow
import React, { useEffect, useState } from "react";
import PageContainer from "../containers/PageContainer";
import CheckoutForm from "../containers/CheckoutForm";
import { useTranslation } from 'react-i18next';
import { ElementsConsumer, Elements } from '@stripe/react-stripe-js';
import { loadStripe } from '@stripe/stripe-js';
import { useDispatch, useSelector  } from 'react-redux'





export default function CheckoutView() {

    const { t } = useTranslation();
    const dispatch = useDispatch();
    const settings = useSelector((state) => state.settings);
    const [stripePromise, setStripePromise] = useState(null);
    const options = {
        // passing the client secret obtained from the server
        // clientSecret: "{{CLIENT_SECRET}}",
        locale: settings.locale ? settings.locale : "en-US"
    };

    useEffect(() => {
      if (
          settings &&
          settings.isStripeElementsFeatureEnabled &&
          settings.stripePublicApiKey
      ) {
          setStripePromise(loadStripe(settings.stripePublicApiKey));
      }
  }, [settings.stripePublicApiKey]);

    const checkout = settings.isStripeElementsFeatureEnabled || stripePromise === null ? (
        <PageContainer title={t("Checkout")} showShopToolbar={false}>
            <Elements stripe={stripePromise} options={options}>
                <ElementsConsumer>
                    {({ stripe, elements }) => (
                        <CheckoutForm stripe={stripe} elements={elements} />
                    )}
                </ElementsConsumer>
            </Elements>
        </PageContainer>
    ) : (
        <PageContainer title={t("Checkout")} showShopToolbar={false}>
            <CheckoutForm />
        </PageContainer>
    );

    

    return ( checkout );
}
